import { Menu, MenuItem } from "@itwin/itwinui-react";
import { FieldDataNode } from "rc-tree";
import { ExplorerDataNode } from "../treeDataManipulation";
import styles from "./ContextMenu.module.css";

export type ContextMenuType = "default" | "file" | "folder" | "batch";

interface ContextMenuOptions {
  targetNode: FieldDataNode<ExplorerDataNode>[],
  type: ContextMenuType;
  onNewFile?: (filePath: string) => void;
  onRename?: () => void;
  onDelete?: (filePath: string[]) => void;
  onNewFolder?: (filePath: string) => void;
  onEntry?: (filePath: string) => void;
  onUpload?: (baseFilePath: string) => void;
}

export const getContextMenuItems = ({ targetNode, type, onNewFile, onRename, onDelete, onNewFolder, onEntry, onUpload }: ContextMenuOptions) => {

  // It's guaranteed that at least one node is provided to context menu on right click in explorer
  const filePath = targetNode[0].key;
  const baseFilePath = targetNode[0].isLeaf ? targetNode[0].key.slice(0, targetNode[0].key.lastIndexOf("/")) : targetNode[0].key;
  const isReadOnly = targetNode.some((node) => node.readOnly);

  const defaultMenuItems = (close: () => void) => {
    return <Menu className={styles.contextMenu}>
      <MenuItem disabled={isReadOnly} onClick={() => { onNewFile && onNewFile("/"); close(); }}>New File</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onNewFolder && onNewFolder("/"); close(); }}>New Folder</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onUpload && onUpload(baseFilePath); close(); }}>Upload Files</MenuItem>
    </Menu>
  };

  const fileMenuItems = (close: () => void) => {

    return <Menu className={styles.contextMenu}>
      <MenuItem disabled={!/^.*\.(js|jsx|ts|tsx)/.test(filePath) || isReadOnly} onClick={() => { onEntry && onEntry(filePath); close(); }} >Set Entry</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onRename && onRename(); close(); }}>Rename</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onDelete && onDelete([filePath]); close(); }}>Delete</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onUpload && onUpload(baseFilePath); close(); }}>Upload Files</MenuItem>
    </Menu>
  };

  const folderMenuItems = (close: () => void) => {
    return <Menu className={styles.contextMenu}>
      <MenuItem disabled={isReadOnly} onClick={() => { onNewFile && onNewFile(filePath ?? "/"); close(); }}>New File</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onNewFolder && onNewFolder(filePath ?? "/"); close(); }}>New Folder</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onRename && onRename(); close(); }}>Rename</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onDelete && onDelete([filePath]); close(); }}>Delete</MenuItem>
      <MenuItem disabled={isReadOnly} onClick={() => { onUpload && onUpload(baseFilePath); close(); }}>Upload Files</MenuItem>
    </Menu>
  };

  const batchMenuItems = (close: () => void) => {

    return <Menu className={styles.contextMenu}>
      <MenuItem disabled={isReadOnly} onClick={() => { onDelete && onDelete(targetNode.map((item) => item.key)); close(); }}>Delete</MenuItem>
    </Menu>
  };

  if (type === "file")
    return { menuItems: fileMenuItems };

  if (type === "folder")
    return { menuItems: folderMenuItems };

  if (type === "batch")
    return { menuItems: batchMenuItems }

  return { menuItems: defaultMenuItems };
}
